<template>
  <div class="yxy-toast" v-show="show">
    <div class="weui-mask_transparent" v-show="isShowMask && show"></div>
    <transition :name="transition">
      <div class="weui-toast" :class="{'weui-toast_text': type === 'text'}"
        :style="{width: width}" v-show="show">
        <i :class="toastClass" class="weui-icon_toast" v-show="type !== 'text'"></i>
        <p class="weui-toast__content" v-if="text" v-html="text"></p>
        <p class="weui-toast__content" v-else><slot></slot></p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'toast',
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 1000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: {
      type: String,
      default: 'yxy-fade'
    },
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: true
    },
    text: String
  },
  data () {
    return {
      show: false
    }
  },
  created () {
    if (this.value) {
      this.show = true
    }
  },
  computed: {
    toastClass () {
      return {
        'weui-icon-warn': this.type === 'warn',
        'weui-icon-cancel': this.type === 'cancel',
        'weui-icon-success-no-circle': this.type === 'success',
        '': this.type === 'text'
      }
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.$emit('input', true)
        this.$emit('on-show')
      }
      if (val) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.show = false
          this.$emit('input', false)
          this.$emit('on-hide')
        }, this.time)
      }
    },
    value (val) {
      this.show = val
    }
  }
}
</script>
